import { Box, Button, Popover, } from '@mui/material';
import { useAppbar, } from '../../hooks';
import ScrollableTabsButtonForce from './ScrollableTabsButtonForce';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const StyledPopover = ({ id, children, ...props }) => {
    const { anchorElLibrary, customizedTabsLibraryClose, } = useAppbar();

    return (
            <Popover
                id={id}
                elevation={0}
                open={Boolean(anchorElLibrary)}
                anchorEl={anchorElLibrary}
                onClose={customizedTabsLibraryClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                sx={{
                    '& .MuiPopover-paper': {
                        border: 1,
                        borderColor: 'borderColor.main',
                        boxShadow: 2,
                        color: 'text.primary',
                        mt: 1,
                        '&:hover': {
                            boxShadow: 5,
                        },
                    },
                }}
                {...props}
            >
                {children}
            </Popover>
    );
};

export default function LibraryCustomizedTabs ({sx = [], ...props}) {
    const { anchorElLibrary, customizedTabsLibraryOpen, } = useAppbar();

    const id = Boolean(anchorElLibrary) ? 'simple-popover' : undefined;

    return (
        <Box sx={[
            ...(Array.isArray(sx) ? sx : [sx])
        ]} {...props}>
            <Button
                aria-describedby={id}
                variant='outlined'
                onClick={(event) => customizedTabsLibraryOpen(event)}
                endIcon={<KeyboardArrowDownIcon />}
                sx={{
                    border: 1,
                    borderColor: 'borderColor.main',
                    color: 'text.primary',
                    '&:hover': {
                        border: 1,
                        borderColor: 'secondary.main',
                        color: 'secondary.main',
                    },
                }}>
                Библиотека
            </Button>
            <StyledPopover id={id}>
                <ScrollableTabsButtonForce sx={{ minWidth: 500, maxWidth: 617, }} />
            </StyledPopover>
        </Box>
    );
};